import { Vector3 } from "three";
import { IMeasurementHandler } from "./types";
import { LastSavedPointsCache } from "./lastSavedPointsCache";

/**
 * QU3DW-1379 (SC_QUICK-2063) — apply the last value saved on the server back
 * onto a measurement, used when the user cancels an edit session so dragged
 * points do not stick.
 */
export function restoreLastSavedPoints(
  measurement: IMeasurementHandler | undefined,
  lastSavedPoints: Vector3[] | undefined
): void {
  if (!measurement || !lastSavedPoints) return;
  measurement.setPoints(lastSavedPoints.map((p) => p.clone()));
}

/**
 * QU3DW-1379 (SC_QUICK-2063) — wiring used by
 * MeasurementManager.cancelEditingMeasurement(): look up the active
 * measurement's id in the lastSavedPoints cache and restore it.
 */
export function restoreActiveMeasurementFromCache(
  activeMeasurement: IMeasurementHandler | undefined,
  lastSavedPoints: LastSavedPointsCache
): void {
  if (!activeMeasurement) return;
  restoreLastSavedPoints(
    activeMeasurement,
    lastSavedPoints.get(activeMeasurement.id)
  );
}
